module.exports = __webpack_public_path__ + "static/img/robocop.1685ac3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/robocop.svg
// module id = 3zDz
// module chunks = 0